<template>
	<v-container>
		<v-row
			v-if="selectedItems.length > 0"
			class="d-flex align-center rounded-lg"
			:style="{ background: elementBackgroundColor }"
		>
			<v-col cols="6" class="start">
				<span :style="{ color: elementTextColor }" class="element">
					{{ selectedItems.length }} item(s) selected
				</span>
			</v-col>
			<v-col cols="6" class="end delete">
				<v-btn
					@click="deleteSelection(selectedItems)"
					prepend-icon="mdi-delete"
					variant="outlined"
					:style="{ color: elementTextColor }"
					class="delete"
					>DELETE</v-btn
				>
			</v-col>
		</v-row>
		<v-row justify="start">
			<v-col>
				<v-data-table
					:headers="headers"
					:items="ruleslist"
					:sort-by="[{ key: 'name', order: 'asc' }]"
					:items-per-page="15"
					:items-per-page-options="[
						{ value: 15, title: '15' },
						{ value: 30, title: '30' },
						{ value: 50, title: '50' },
						{ value: 100, title: '100' },
					]"
					loading-text="Loading... Please wait"
					:multi-sort="true"
					:hover="true"
					:show-select="shouldShowSelect"
					v-model="selectedItems"
				>
					<template v-slot:top>
						<div class="d-flex align-center">
							<span class="font-weight-medium">Rules by Amount</span>
							<v-spacer></v-spacer>
							<v-dialog v-model="dialog" max-width="75%">
								<template v-slot:activator="{ props }">
									<v-btn variant="outlined" v-bind="props">New Rule</v-btn>
								</template>
								<v-card>
									<v-card-title>
										<span class="font-weight-bold">{{ itemTitle }}</span>
									</v-card-title>

									<v-card-text>
										<v-container>
											<input type="hidden" v-model="editItem.id" />
											<v-text-field
												class="w-auto"
												variant="outlined"
												v-model="editItem.name"
												label="Name"
											></v-text-field>
											<v-autocomplete
												v-model="editItem.responsCodeId"
												:items="responsecodelist"
												item-title="name"
												item-value="id"
												label="Response Code"
												class="w-auto"
												variant="outlined"
											></v-autocomplete>
											<v-text-field
												class="w-auto"
												variant="outlined"
												v-model="editItem.amount"
												type="number"
												label="Amount"
											>
											</v-text-field>
										</v-container>
									</v-card-text>
									<v-divider class="mt-5"></v-divider>
									<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn variant="text" @click="close">Cancel</v-btn>
										<v-btn
											color="primary"
											variant="text"
											@click="funSaveItem"
											:loading="loading"
											>Save</v-btn
										>
									</v-card-actions>
								</v-card>
							</v-dialog>
						</div>
					</template>
					<template v-slot:[`item.action`]="{ item }">
						<v-icon small @click="funEditItem(item)"
							>mdi-pencil</v-icon
						>
						<v-icon small @click="funDeleteItem(item)"
							>mdi-delete</v-icon
						>
					</template>
					<template v-slot:no-data>
						<span>No Data Available</span>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
	CREATE_RULESBYAMOUNT,
	EDIT_RULESBYAMOUNT,
	REMOVE_RULESBYAMOUNT,
	REMOVE_RULESBYAMOUNTS,
} from "@/store/_actiontypes";

export default {
	data: () => ({
		loading: false,
		dialog: false,
		menu: false,
		selectedItems: [],
		timer: undefined,

		headers: [
			{ title: "Id", key: "id", align: " d-none" },
			{ title: "Name", key: "name" },
			{ title: "Amount", key: "amount" },
			{ title: "Response Code", key: "responsCodeName" },
			{ title: "Actions", key: "action", sortable: false, width: 50 },
		],
		editItem: {
			id: 0,
			name: "",
			amount: 0,
			responsCodeId: "KRIVI PIN",
			responsCodeName: "",
		},
		defaultItem: {
			id: 0,
			name: "",
			amount: 0,
			responsCodeId: "1",
			responsCodeName: "",
		},
	}),

	computed: {
		...mapState("responscodes", ["responsecodelist"]),
		...mapState({ ruleslist: (state) => state.rulesbyamount.ruleslist }),
		itemTitle() {
			return this.editItem.id === 0 ? "New Rule" : "Edit Rule";
		},
		shouldShowSelect() {
			return this.ruleslist.length >= 1;
		},
		elementTextColor() {
			return this.$vuetify.theme.global.name === "dark" ? "white" : "black";
		},
		elementBackgroundColor() {
			return this.$vuetify.theme.global.name === "dark" ? "#3d1924" : "#cfe4f2";
		},
	},

	watch: {
		dialog(val) {
			val || this.close();
		},
		selectedItems(val) {
			this.selectedItems = val;
		},
	},

	methods: {
		...mapActions("rulesbyamount", [
			CREATE_RULESBYAMOUNT,
			EDIT_RULESBYAMOUNT,
			REMOVE_RULESBYAMOUNT,
			REMOVE_RULESBYAMOUNTS,
		]),

		funEditItem(item) {
			this.editItem = Object.assign({}, item);
			this.dialog = true;
		},

		funDeleteItem(item) {
			confirm("Are you sure you want to delete this item?") &&
				this.REMOVE_RULESBYAMOUNT({ id: item.id });
		},

		deleteSelection() {
			this.loading = true;
			const ids = [];
			for (var val in this.selectedItems) {
				ids.push(this.selectedItems[val]);
			}
			if (
				confirm(
					`Are you sure you want to delete ${ids.length} selected item(s)?`
				)
			) {
				this.REMOVE_RULESBYAMOUNTS({ ids: ids }).then(() => {
					this.loading = false;
				});
				this.selectedItems = [];
			}
		},

		close() {
			this.dialog = false;
		},

		funSaveItem() {
			this.loading = true;
			var item = this.editItem;
			if (item.id == 0) {
				if (!Number.isInteger(item.responsCodeId)) {
					item.responsCodeId = this.defaultItem.responsCodeId;
				}
				this.CREATE_RULESBYAMOUNT({
					item,
				})
					.then(() => {
						this.close();
					})
					.finally(() => {
						this.loading = false;
					});
			} else {
				this.EDIT_RULESBYAMOUNT({
					item,
				})
					.then(() => {
						this.close();
					})
					.finally(() => {
						this.loading = false;
					});
			}
		},
	},
};
</script>

<style>
.element {
	padding: 10px;
	border: none;
	color: black;
}

.start {
	display: flex;
	justify-content: flex-start;
}

.end {
	display: flex;
	justify-content: flex-end;
	align-items: center;
}

.delete {
	cursor: pointer;
}
</style>
